export default {
  name: 'organizationSeal',
  dataForm: {
    "image_ids": [], // optional - Ảnh chữ ký
    "company_id": undefined, // optional, ref: company - Mã công ty
    "created_at": undefined, // required - Thời điểm tạo
    "updated_at": undefined, // required - Thời điểm cập nhật
    "disabled": undefined, // required - Đã bị khóa chưa
  }
}